import PageHeader from "../common/pageHeader/v2";
import Features from "../components/section/features/v2";

const FeturesPage = () => {
  return (
    <>
      <PageHeader title="features" subTitle="features" />
      <Features />
    </>
  );
};

export default FeturesPage;
